(function () {
  'use strict';

  // Screenshot-Modus für Präsentationen: ?mockup[&s=<Selektor>][&open=<Menü-ID>][&burger]
  var params = new URLSearchParams(location.search);
  var MOCKUP = params.has('mockup');
  if (MOCKUP) document.documentElement.classList.add('mockup');

  /* Sprache ---------------------------------------------------------------- */
  var dict = window.FOTHERMO_I18N || {};
  var langs = ['de', 'en', 'es'];
  var STORAGE_KEY = 'fothermo-lang';
  var scope = document.body.dataset.product;   // z. B. "rod-1000" auf Produktseiten

  // Produktspezifischer Text ("rod-1000:pdp.price") hat Vorrang vor dem allgemeinen ("pdp.price")
  function lookup(t, key) {
    if (scope && (scope + ':' + key) in t) return t[scope + ':' + key];
    return key in t ? t[key] : null;
  }

  function storedLang() {
    try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function initialLang() {
    var fromUrl = new URLSearchParams(location.search).get('lang');
    if (langs.indexOf(fromUrl) > -1) return fromUrl;
    var saved = storedLang();
    return langs.indexOf(saved) > -1 ? saved : 'de';
  }

  function setLang(lang) {
    var t = dict[lang];
    if (!t) return;
    document.documentElement.lang = lang;
    // Nur Seiten mit data-title-key lassen ihren Titel übersetzen (Wissen-Artikel behalten den deutschen Titel)
    var titleKey = document.body.dataset.titleKey;
    var title = titleKey && lookup(t, titleKey);
    if (title) document.title = title;

    document.querySelectorAll('[data-i18n]').forEach(function (el) {
      var val = lookup(t, el.getAttribute('data-i18n'));
      if (val !== null) el.innerHTML = val;
    });
    document.querySelectorAll('[data-i18n-alt]').forEach(function (el) {
      var val = lookup(t, el.getAttribute('data-i18n-alt'));
      if (val !== null) el.alt = val;
    });
    document.querySelectorAll('.lang-switch button').forEach(function (btn) {
      btn.setAttribute('aria-pressed', String(btn.dataset.lang === lang));
    });
    try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) { /* egal */ }
  }

  document.querySelectorAll('.lang-switch button').forEach(function (btn) {
    btn.addEventListener('click', function () { setLang(btn.dataset.lang); });
  });
  setLang(initialLang());


  /* Sprachmenü: bei Klick außerhalb oder Escape schließen */
  document.querySelectorAll('[data-lang-menu]').forEach(function (m) {
    document.addEventListener('click', function (e) { if (m.open && !m.contains(e.target)) m.open = false; });
    m.addEventListener('keydown', function (e) { if (e.key === 'Escape') { m.open = false; m.querySelector('summary').focus(); } });
  });
  /* Reveal beim Scrollen -------------------------------------------------- */
  var revealEls = document.querySelectorAll('.reveal, .reveal-scale');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* So funktioniert's: Hotspots <-> Schritte ------------------------------ */
  var steps = document.querySelectorAll('.step');
  var hotspots = document.querySelectorAll('.hotspot');

  function activate(index) {
    steps.forEach(function (s) { s.classList.toggle('is-active', s.dataset.step === String(index)); });
    hotspots.forEach(function (h) { h.classList.toggle('is-active', h.dataset.step === String(index)); });
  }

  steps.forEach(function (s) {
    s.addEventListener('click', function () { activate(s.dataset.step); });
    s.addEventListener('mouseenter', function () { activate(s.dataset.step); });
  });
  hotspots.forEach(function (h) {
    h.addEventListener('click', function () { activate(h.dataset.step); });
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(h.dataset.step); }
    });
  });
  if (steps.length) activate(0);

  /* Produkte-Menü: Hover am Desktop, Klick/Tastatur überall ----------------- */
  document.querySelectorAll('[data-menu]').forEach(function (item) {
    var trigger = item.querySelector('.nav-trigger');
    var menu = item.querySelector('.menu');
    var closeTimer;
    var canHover = window.matchMedia('(hover: hover)').matches;

    function open() {
      clearTimeout(closeTimer);
      menu.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    trigger.addEventListener('click', function () {
      // Mit Maus ist das Menü schon per Hover offen – ein Klick soll es dann nicht wieder schließen
      if (menu.hidden || canHover) open(); else close();
    });
    if (canHover) {
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', function () { closeTimer = setTimeout(close, 180); });
    }
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { close(); trigger.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!item.contains(e.target)) close();
    });
    menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', close); });
  });

  /* Mobile: Menü-Symbol öffnet die Navigation ------------------------------ */
  var burger = document.querySelector('.nav-burger');
  var mainNav = document.querySelector('.nav');
  if (burger && mainNav) {
    var setNav = function (open) {
      mainNav.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', String(open));
    };
    burger.addEventListener('click', function (e) {
      e.stopPropagation();
      setNav(!mainNav.classList.contains('is-open'));
    });
    mainNav.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { setNav(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setNav(false); });
    document.addEventListener('click', function (e) {
      if (!mainNav.contains(e.target) && e.target !== burger) setNav(false);
    });
  }

  /* Aktionsleiste: Code kopieren & schließen ------------------------------ */
  document.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var done = function () {
        btn.classList.add('is-copied');
        setTimeout(function () { btn.classList.remove('is-copied'); }, 1400);
      };
      if (navigator.clipboard) navigator.clipboard.writeText(btn.dataset.copy).then(done, done);
      else done();
    });
  });
  var promoClose = document.querySelector('.promo-bar__close');
  if (promoClose) promoClose.addEventListener('click', function () {
    document.querySelector('.promo-bar').classList.add('is-hidden');
    document.body.classList.remove('has-promo');
  });

  /* Produkte-Menü: Kategorien umschalten ------------------------------------ */
  document.querySelectorAll('.menu__inner--cats').forEach(function (wrap) {
    var cats = wrap.querySelectorAll('.menu__cat'), panels = wrap.querySelectorAll('.menu__panel');
    function show(id) {
      cats.forEach(function (c) { c.classList.toggle('is-active', c.dataset.cat === id); });
      panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === id); });
    }
    cats.forEach(function (c) {
      c.addEventListener('mouseenter', function () { show(c.dataset.cat); });
      c.addEventListener('focus', function () { show(c.dataset.cat); });
      c.addEventListener('click', function () { show(c.dataset.cat); });
    });
    // Auf Produktseiten die passende Kategorie vorwählen
    var activeCat = wrap.querySelector('.menu__cat[data-current]');
    show(activeCat ? activeCat.dataset.cat : (cats[0] && cats[0].dataset.cat));
  });

  /* Produktseite: Shopify-Varianten ------------------------------------------
     Bilder je Variante: Alt-Text des Bildes = Variantenname (z. B. „30 L“).
     Bilder ohne passenden Alt-Text erscheinen bei allen Varianten. */
  var pSel = document.querySelector('[data-variant-select]');
  var pJson = document.querySelector('[data-product-json]');
  if (pSel && pJson) {
    var pData = JSON.parse(pJson.textContent);
    var names = pData.variants.map(function (v) { return v.title.trim().toLowerCase(); });
    var setVariant = function (i, first) {
      var v = pData.variants[i];
      var idInput = document.querySelector('[data-variant-id]');
      if (idInput) idInput.value = v.id;
      var price = document.querySelector('[data-variant-price]');
      if (price) price.textContent = v.price;
      var buy = document.querySelector('[data-variant-buy]');
      if (buy) { buy.disabled = !v.available; buy.textContent = v.available ? pData.labels.add : pData.labels.sold; }
      document.querySelectorAll('[data-vt]').forEach(function (el) { var a = JSON.parse(el.dataset.vt); el.textContent = a[Math.min(i, a.length - 1)]; });
      document.querySelectorAll('[data-vh]').forEach(function (el) { var a = JSON.parse(el.dataset.vh); el.innerHTML = a[Math.min(i, a.length - 1)]; });
      var firstThumb = null;
      document.querySelectorAll('.gallery__thumb').forEach(function (t) {
        var alt = (t.dataset.alt || '').trim().toLowerCase();
        var ok = names.indexOf(alt) === -1 || alt === names[i];
        t.hidden = !ok;
        t.setAttribute('aria-current', 'false');
        if (ok && !firstThumb) firstThumb = t;
      });
      if (firstThumb) {
        firstThumb.setAttribute('aria-current', 'true');
        var st = document.querySelector('.gallery__stage img');
        if (st && !first) {
          st.srcset = firstThumb.dataset.srcset || ''; st.removeAttribute('sizes'); st.src = firstThumb.dataset.src;
        } else if (st && first && firstThumb.dataset.src) {
          st.srcset = firstThumb.dataset.srcset || ''; st.removeAttribute('sizes'); st.src = firstThumb.dataset.src;
        }
      }
      if (!first) { try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {} }
    };
    pSel.addEventListener('change', function () { setVariant(+pSel.value); });
    setVariant(+pSel.value, true);
  }

  /* Produktseite: Galerie ------------------------------------------------- */
  var stage = document.querySelector('.gallery__stage img');
  document.querySelectorAll('.gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (!stage || thumb.getAttribute('aria-current') === 'true') return;
      document.querySelectorAll('.gallery__thumb').forEach(function (t) { t.setAttribute('aria-current', 'false'); });
      thumb.setAttribute('aria-current', 'true');
      stage.classList.add('is-fading');
      setTimeout(function () {
        stage.onload = function () { stage.classList.remove('is-fading'); };
        // Shopify liefert srcset/sizes mit – die haben Vorrang vor src und müssen mitgewechselt werden
        if (thumb.dataset.srcset) stage.srcset = thumb.dataset.srcset; else stage.removeAttribute('srcset');
        stage.removeAttribute('sizes');
        stage.src = thumb.dataset.src;
        if (stage.complete) stage.classList.remove('is-fading');
      }, 200);
    });
  });

  /* Produktseite: Warenkorb-Demo ------------------------------------------ */
  var toast = document.querySelector('.toast');
  var toastTimer;
  document.querySelectorAll('[data-demo-cart]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!toast) return;
      toast.classList.add('is-visible');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 3200);
    });
  });

  if (MOCKUP) {
    document.querySelectorAll('.reveal, .reveal-scale, [data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
    if (params.has('burger') && burger) { mainNav.classList.add('is-open'); burger.setAttribute('aria-expanded', 'true'); }
    var menuId = params.get('open');
    var menuEl = menuId && document.getElementById(menuId);
    if (menuEl) {
      menuEl.hidden = false;
      var trig = document.querySelector('[aria-controls="' + menuId + '"]');
      if (trig) trig.setAttribute('aria-expanded', 'true');
    }
    var sel = params.get('s');
    if (sel) {
      var target = document.querySelector(sel);
      if (target) window.scrollTo(0, target.getBoundingClientRect().top + window.scrollY - (+params.get('off') || 56));
    }
  }
})();

/* Mengenauswahl (+/−) auf der Produktseite */
document.addEventListener('click', function (e) {
  var b = e.target.closest('[data-qty-step]'); if (!b) return;
  var input = b.closest('[data-qty]').querySelector('input');
  var v = Math.max(1, Math.min(99, (parseInt(input.value, 10) || 1) + Number(b.dataset.qtyStep)));
  input.value = v;
});
